import { createReducer, REQUEST, SUCCESS, updateObject } from 'Stores'
import { BLOCK_OR_ACTIVE_USER, GET_ALL_PORTFOLIO_BY_USER_ID, GET_INFO_USER_AND_PORTFOLIO, GET_USER_LIST } from './constants'

export const initialState = {
  isLoading: false,
  error: null,
  filter: {
    search: '',
    isActive: null,
    status: null,
    action: null,
    lastLogin: null,
    company: null
  },
  pagination: {
    page: 1,
    pageSize: 10
  },
  total: 0,
  users: [],
  info: {},
  portfolios: []
}

function getUserList(state, { payload }) {
  const { action, search, isActive, status, last_login: lastLogin, company, page, pageSize } = payload
  const filter = {
    search,
    isActive,
    action,
    status,
    lastLogin,
    company
  }
  const pagination = {
    page,
    pageSize
  }
  return updateObject(state, {
    isLoading: true,
    filter,
    pagination
  })
}

function getUserListSuccess(state, { payload }) {
  const { users, total } = payload
  return updateObject(state, {
    isLoading: false,
    users,
    total
  })
}

function blockOrActiveUserSuccess(state) {
  return updateObject(state, {
    isLoading: false
  })
}

function getAllPortfolioByUserId(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function getAllPortfolioByUserIdSuccess(state, { payload }) {
  const { portfolios } = payload
  return updateObject(state, {
    isLoading: false,
    portfolios
  })
}

function getInfoUserAndPortfolioSuccess(state, { payload }) {
  const { info } = payload
  return updateObject(state, {
    isLoading: false,
    info
  })
}

export default createReducer(initialState, {
  [REQUEST(GET_USER_LIST)]: getUserList,
  [SUCCESS(GET_USER_LIST)]: getUserListSuccess,
  [SUCCESS(BLOCK_OR_ACTIVE_USER)]: blockOrActiveUserSuccess,
  [REQUEST(GET_ALL_PORTFOLIO_BY_USER_ID)]: getAllPortfolioByUserId,
  [SUCCESS(GET_ALL_PORTFOLIO_BY_USER_ID)]: getAllPortfolioByUserIdSuccess,
  [SUCCESS(GET_INFO_USER_AND_PORTFOLIO)]: getInfoUserAndPortfolioSuccess
})
